import React from "react";

export default function RecipeRegimeTag({ regime }) {
    return (
        <div className="recipe_regime_tag_container">
            <p>{regime}</p>
        </div>
    )
}